import { createContext, Dispatch, SetStateAction } from 'react'

import { TaskModes, InitialConfigState } from 'domains/Workspaces/ContentFlows/AvcTasks/AvcTask/Task/context'

export const AVCTaskContext = createContext<{
  taskMode: TaskModes
  initialConfigState?: InitialConfigState
  setTaskMode?: Dispatch<SetStateAction<{ taskMode: TaskModes; initialConfigState?: InitialConfigState }>>
}>({ taskMode: 'read', setTaskMode: () => null })
